/**
 * Рекордер записи обучения, общий для приложения. Создается там, где есть
 * браузер и сеть (redux/store.js), а читается из мест, которые работают и без
 * них: middleware сценария обучения гоняется в headless-пробниках и тестах,
 * где рекордера нет вовсе — тогда все вызовы просто ничего не делают.
 */
let recorder = null;
let localMatchRecorder = null;

export const setTutorialReplayRecorder = (nextRecorder) => {
  recorder = nextRecorder || null;
};

export const getTutorialReplayRecorder = () => recorder;

// Тот же движок записи, но для локальных матчей: свой транспорт и отправка
// раз в раунд (см. localMatchReplayMiddleware)
export const setLocalMatchReplayRecorder = (nextRecorder) => {
  localMatchRecorder = nextRecorder || null;
};

export const getLocalMatchReplayRecorder = () => localMatchRecorder;
